import Vue from 'vue'
import isMatchWith from 'lodash.ismatchwith'
import router from '@/modules/router'
import store from '@/modules/store'

const getId = (iri) => {
    return iri && (typeof iri === 'string' || iri instanceof String)
        ? parseInt(iri.substr(iri.lastIndexOf('/') + 1, iri.length - iri.lastIndexOf('/')))
        : null
}

const isUndefined = (value) => value === null || value === undefined

const isDeepEqual = (a, b) => {
    if (isUndefined(a) && isUndefined(b)) return true
    else if (isUndefined(a) || isUndefined(b)) return false
    return (
        a.length === b.length &&
        a.every((x) => b.some((y) => Object.keys(x).every((key) => x[key] === y[key])))
    )
}
Vue.mixin({
    methods: {
        sortNull(array, key = 'position') {
            if (!array) return null
            return JSON.parse(JSON.stringify(array)).sort((a, b) => {
                if (a[key] === null && b[key] === null) return 0
                if (a[key] === null) return 1
                else if (b[key] === null) return -1
                else return a[key] - b[key]
            })
        },
        setQuery(query, name, options = {}, onComplete = () => {}) {
            const oldQuery = this.$route.query
            const newQuery = { ...this.$route.query, ...query }

            if (isMatchWith(oldQuery, newQuery, (a, b) => a?.toString() === b?.toString())) {
                onComplete()
                return
            }
            router.replace(
                {
                    name: name ? name : this.$route.name,
                    params: this.$route.params,
                    query: newQuery,
                    meta: options,
                    hash: this.$route.hash,
                },
                () => {
                    onComplete()
                },
                (e) => {
                    window.debug.error('Error in setQuery [global.js]\n', e)
                }
            )
        },

        getFullName(user) {
            return store.getters['locale'] === 'hu'
                ? `${user.last_name} ${user.first_name}`
                : `${user.first_name} ${user.last_name}`
        },

        getId: getId,
        isDeepEqual: isDeepEqual,
        isUndefined: isUndefined,
    },
})

export default { getId, isDeepEqual }
